// Scrollbar-Breite: schreibt die Breite der vertikalen Scrollleiste in die
// CSS-Variable --bfw-scrollbar-width auf <html>. .full-width-breakout in
// _sections.scss zieht sie von 100vw ab (Overlay-Scrollbars/Mobile: 0px).
export function initScrollbarWidth() {
  const root = document.documentElement;
  const update = () => {
    root.style.setProperty('--bfw-scrollbar-width', `${window.innerWidth - root.clientWidth}px`);
  };

  update();
  // Fängt Resize und das Ein-/Ausblenden der Scrollleiste bei Höhenänderung ab.
  new ResizeObserver(update).observe(root);
}
